/**
 * Created by fers on 05.02.16.
 */

import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';

import Editor from '../fw/Editor.react';
import urlMapping from '../app/URLMapping';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'relationDefAdd.title', 'defaultMessage': 'Adding relation definition'}
});

interface RelationDefAddProps {
    intl: IntlShape;
    relay: object;
    user: User;
}

class RelationDefAdd extends React.Component<RelationDefAddProps> {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'relationDefs';

    constructor(props) {
        super(props);

        this.state = {
            fromChannelId: null,
            toChannelId: null,
            fromEntityId: null,
            toEntityId: null,
        };
    }

    render() {
        let type = types[this.typeName];

        let fromEntities = [];
        let fromChannelEntities = [];
        let toEntities = [];
        let toChannelEntities = [];
        let fromFields = [];
        let toFields = [];

        if (this.state.fromChannelId !== null) {
            let channel = this.props.user.organisation.channels.edges.find(({node}) => node['id'] === this.state.fromChannelId).node;
            fromChannelEntities = channel.channelDef.channelEntityDefs.edges.map(({node}) => node);
            fromEntities = fromChannelEntities.map((node) => node.entityDef).filter((a) => a ? true : false);
        }

        if (this.state.toChannelId !== null) {
            let channel = this.props.user.organisation.channels.edges.find(({node}) => node['id'] === this.state.toChannelId).node;
            toChannelEntities = channel.channelDef.channelEntityDefs.edges.map(({node}) => node);
            toEntities = toChannelEntities.map((node) => node.entityDef).filter((a) => a ? true : false);
        }

        if (this.state.fromEntityId !== null && fromEntities !== null) {
            let channelEntityDef = fromChannelEntities.find((node) => node.entityDef && node.entityDef['id'] === this.state.fromEntityId);
            if (channelEntityDef) {
                fromFields = channelEntityDef.usedFieldDefs.edges.map(({node}) => node);
            }
        }

        if (this.state.toEntityId !== null && toEntities !== null) {
            let channelEntityDef = toChannelEntities.find((node) => node.entityDef && node.entityDef['id'] === this.state.toEntityId);
            if (channelEntityDef) {
                toFields = channelEntityDef.usedFieldDefs.edges.map(({node}) => node);
            }
        }

        return (
            <AppPanel breadcrumbParams={[
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <Editor
                    columns={{
                        'name': {},
                        'type': {},
                        'description': {},
                        'fromChannel': {
                            values: this.props.user.organisation.channels.edges.map(({node}) => node),
                            display: (item) => {
                                if (item['name']) {
                                    return item['name'] + " / " + item['channelDef']['name'];
                                } else {
                                    return item['channelDef']['name'];
                                }
                            },
                            onChange: (e, key) => {
                                this.setState({fromChannelId: key});
                            },
                        },
                        'fromEntity': {
                            values: fromEntities,
                            display: (item) => {
                                return item['name'] + " (" + item['groupDef']['name'] + ")";
                            },
							// eslint-disable-next-line max-params
                            onChange: (e, key, payload, modifyValues) => {
                                this.setState({fromEntityId: key});

                                let channelEntityDef = fromChannelEntities.find((node) => node.entityDef && node.entityDef['id'] === key);
                                if (channelEntityDef && channelEntityDef.primaryFieldDef) {
                                    modifyValues('fromField', channelEntityDef.primaryFieldDef);
                                }
                            },
                        },
                        'fromField': {
                            values: fromFields,
                            display: (item) => {
                                if (item) {
                                    return item['name'] + " (" + item['key'] + ": " + item['type'] + ")";
                                }
                            }
                        },
                        'toChannel': {
                            values: this.props.user.organisation.channels.edges.map(({node}) => node),
                            display: (item) => {
                                if (item['name']) {
                                    return item['name'] + " / " + item['channelDef']['name'];
                                } else {
                                    return item['channelDef']['name'];
                                }
                            },
                            onChange: (e, key) => {
                                this.setState({toChannelId: key});
                            },
                        },
                        'toEntity': {
                            values: toEntities,
                            display: (item) => {
                                return item['name'] + " (" + item['groupDef']['name'] + ")";
                             },
							// eslint-disable-next-line max-params
                            onChange: (e, key, payload, modifyValues) => {
                                this.setState({toEntityId: key});

                                let channelEntityDef = toChannelEntities.find((node) => node.entityDef && node.entityDef['id'] === key);
                                if (channelEntityDef && channelEntityDef.primaryFieldDef) {
                                    modifyValues('toField', channelEntityDef.primaryFieldDef);
                                }
                            },
                        },
                        'toField': {
                            values: toFields,
                            display: (item) => {
                                if (item) {
                                    return item['name'] + " (" + item['key'] + ": " + item['type'] + ")";
                                }
                            }
                        },
                    }}
                    extraConfig={[{
                              type: 'RANGE_ADD',
                              parentName: 'organisation',
                              parentID: this.props.user.organisation.id,
                              connectionName: 'relationDefs',
                              edgeName: 'edge',
                              rangeBehaviors: {
                                '': 'append',
                              },
                    }]}
                    fatQuery={Relay.QL `fragment on CreateRelationDefPayload @relay(pattern: true) {
                        edge {
                            node {
                                id,
                            }
                        },
                        organisation {
                            relationDefs(first: 2000) {
                                edges {
                                    node {
                                        id
                                    }
                                }
                            }
                        }
                    }`}
                    isCreate
                    metadata={type}
                    mutation={Relay.QL `mutation { createRelationDef }`}
                    organisationId={this.props.user.organisation.realId}
                    parent={this.props.user.organisation}
                    redirectToList
                    urlMapping={urlMapping}
                />
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(RelationDefAdd), (props) => {
    return props.user.organisation;
}), {
    initialVariables: {
        organisationId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    channels(first: 2000) {
                        edges {
                            node {
                                id,
                                name,
                                channelDef {
                                    id,
                                    name,
                                    channelEntityDefs(first: 20000) {
                                        edges {
                                            node {
                                                id,
                                                entityDef {
                                                    id,
                                                    name,
                                                    key,
                                                    groupDef {
                                                        id,
                                                        name,
                                                        key
                                                    }
                                                },
                                                primaryFieldDef {
                                                    id,
                                                    realId,
                                                    name,
                                                    entityDef_id,
                                                },
                                                usedFieldDefs(first: 20000) {
                                                    edges {
                                                        node {
                                                            id,
                                                            name,
                                                            type,
                                                            key
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
            }
        `,
    },
});
